import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_RAT_URL,
  headers: {},
});

export default instance;
